import { initPosthogClientOnce } from "@/lib/posthog-client-init"
import { isPostHogEnabled } from "@/lib/posthog-enabled"

/**
 * Inlined de propósito — ver comentário em `components/cookie-consent-manager.tsx`.
 * Não importar `lib/cookie-consent.ts` aqui (Turbopack HMR).
 */
const CONSENT_COOKIE_NAME = "astra_cookie_consent"
const CONSENT_ACCEPTED = "accepted"
const CONSENT_REJECTED = "rejected"

function hasOptionalTrackingConsentInDocument(): boolean {
  if (typeof document === "undefined") return true
  const match = document.cookie.match(new RegExp(`(?:^|; )${CONSENT_COOKIE_NAME}=([^;]+)`))
  const value = match?.[1]
  if (value === CONSENT_REJECTED) return false
  if (value === CONSENT_ACCEPTED) return true
  return true
}

if (isPostHogEnabled() && hasOptionalTrackingConsentInDocument()) {
  initPosthogClientOnce()
}
